
import * as React from 'react';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Input from '@mui/material/Input';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

export default function MultiSelect({
    id,
    className,
    placeholder = '',
    options,
    optionLabelKey,
    value,
    onChange,
    multiple,
    input = <Input />,
    ...props
}) {
  const handleChange = (event) => {
    onChange(event.target.value);
  };

  const getText = (option) => {
    return optionLabelKey ? option[optionLabelKey] : option.label || option
  }

  return (
    <Box className={className}>
      <FormControl fullWidth>
        <Select
          displayEmpty
          id={id}
          options={options}
          multiple={multiple}
          value={value}
          onChange={handleChange}
          input={input}
          MenuProps={{ style: { maxHeight: '80%' } }}
          renderValue={(selected) => {
            if (Array.isArray(selected)) {
              const values = selected.map((id, index) => {
                const option = options.find(option => option.id === id);
                if (option) {
                  return <Chip variant='outlined' label={getText(option)} key={option.id} />
                }
                return null;
              }).filter(Boolean);
              if (values.length > 0) {
                return values;
              }
            } else {
              const option = options.find(option => option.id === selected);
              if (option) {
                return getText(option);
              }
            }
            return placeholder;
          }}
          {...props}
        >
          {options.map(option => <MenuItem key={option.id} value={option.id}>{getText(option)}</MenuItem>)}
        </Select>
      </FormControl>
    </Box>
  );
}